import React, { useState } from "react";
import Icon from "@mdi/react";
import { mdiMagnify, mdiTuneVariant } from "@mdi/js";
import { Dropdown, Table } from "react-bootstrap";
import { DateTimePicker } from "react-widgets";
import moment from "moment";
import { utilsOnChangeSelectTypeDate } from "utils/utils";

const LIST_TIME = [
  { key: "1",  value: "Hôm nay" },
  { key: "2",  value: "Hôm qua" },
  { key: "3",  value: "Tuần này" },
  { key: "4",  value: "Tuần trước" },
  { key: "5",  value: "Tháng này" },
  { key: "6",  value: "Tháng trước" },
  { key: "7",  value: "Quý này" },
  { key: "8",  value: "Quý trước" },
  { key: "9",  value: "Năm này" },
  { key: "10", value: "Năm trước" },
  { key: "11", value: "Tuỳ chỉnh thời gian" },
];

export default function SearchBaoGiaDaiLy({
  sMaBaoGia, setSMaBaoGia,
  tuNgay, setTuNgay,
  denNgay, setDenNgay,
  selected, setSelected,
  onSearch, onReset,
}) {
  const [showFilter, setShowFilter]             = useState(false);
  const [showSelectThoiGian, setShowSelectThoiGian] = useState(false);
  const [dateFrom, setDateFrom] = useState(tuNgay ? moment(tuNgay).toDate() : moment().subtract(30, "days").toDate());
  const [dateTo,   setDateTo]   = useState(denNgay ? moment(denNgay).toDate() : new Date());

  const currentKey = selected?.key || "11";

  const handleSelectTime = (key, value) => {
    setSelected({ key, value });
    if (key === "11") {
      setShowSelectThoiGian(true);
      return;
    }
    setShowSelectThoiGian(false);
    const state = { typeDate: key, tuNgay, denNgay };
    utilsOnChangeSelectTypeDate(state);
    setTuNgay(state.tuNgay);
    setDenNgay(state.denNgay);
    setDateFrom(moment(state.tuNgay).toDate());
    setDateTo(moment(state.denNgay).toDate());
  };

  const handleSearch = () => {
    setShowFilter(false);
    onSearch();
  };

  const handleReset = () => {
    setShowFilter(false);
    setShowSelectThoiGian(false);
    setSelected({ key: "11", value: "Tuỳ chỉnh thời gian" });
    onReset();
  };

  return (
    <div className="don-search-ver2">
      <div className="don-search-main">
        <input
          type="text"
          value={sMaBaoGia}
          onChange={(e) => setSMaBaoGia(e.target.value)}
          placeholder="Mã báo giá"
          onKeyDown={(e) => e.key === "Enter" && handleSearch()}
        />
        <button className="don-search-filter-btn" onClick={() => setShowFilter((v) => !v)}>
          <Icon path={mdiTuneVariant} size={1} />
        </button>
        <button className="don-search-icon-btn" onClick={handleSearch}>
          <Icon path={mdiMagnify} size={1.2} />
        </button>
      </div>

      {showFilter && (
        <div className="don-search-dropdown">
          <div className="don-search-dropdown-body">
            <div className="don-search-field">
              <label>Thời gian</label>
              <Dropdown
                show={showSelectThoiGian}
                onToggle={(show) => setShowSelectThoiGian(show)}
              >
                <Dropdown.Toggle id="dropdown-baogiadaily-date" className="don-search-time-toggle">
                  {selected?.value || "Tuỳ chỉnh thời gian"}
                </Dropdown.Toggle>
                <Dropdown.Menu className={currentKey === "11" ? "has-custom-time" : ""}>
                  <Table borderless style={{ marginBottom: 0 }}>
                    <tbody>
                      <tr>
                        <td>
                          {LIST_TIME.map((item) => (
                            <Dropdown.Item
                              key={item.key}
                              className={
                                currentKey === item.key
                                  ? item.key === "11" ? "active-custom" : "active-time"
                                  : ""
                              }
                              eventKey={item.key}
                              onSelect={() => handleSelectTime(item.key, item.value)}
                            >
                              {item.value}
                            </Dropdown.Item>
                          ))}
                        </td>

                        {currentKey === "11" && (
                          <td className="don-date-custom-cell">
                            <div className="don-date-custom">
                              <div>
                                <label>Từ ngày</label>
                                <DateTimePicker
                                  format="DD/MM/YYYY"
                                  time={false}
                                  value={dateFrom}
                                  culture="vi"
                                  onChange={(v) => {
                                    setDateFrom(v);
                                    setTuNgay(moment(v).format("YYYY-MM-DD"));
                                  }}
                                />
                              </div>
                              <div>
                                <label>Đến ngày</label>
                                <DateTimePicker
                                  format="DD/MM/YYYY"
                                  time={false}
                                  value={dateTo}
                                  culture="vi"
                                  onChange={(v) => {
                                    setDateTo(v);
                                    setDenNgay(moment(v).format("YYYY-MM-DD"));
                                  }}
                                />
                              </div>
                              <div className="don-date-custom-actions">
                                <button type="button" onClick={() => handleSelectTime("1", "Hôm nay")}>
                                  Huỷ
                                </button>
                                <button type="button" onClick={() => setShowSelectThoiGian(false)}>
                                  Áp dụng
                                </button>
                              </div>
                            </div>
                          </td>
                        )}
                      </tr>
                    </tbody>
                  </Table>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

          <div className="don-search-dropdown-footer">
            <button type="button" className="don-skip-btn" onClick={handleReset}>
              Bỏ qua
            </button>
            <button type="button" className="don-search-submit-btn" onClick={handleSearch}>
              <Icon path={mdiMagnify} size={0.9} />
              Tìm kiếm
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
